
export class PendienteAlmacen
{
    idOrdenServicio: number;
    ordenServicio: string;
    idCotizacionDetalle: number;
    fechaCotizacion: Date;
    cantidad: number;
    descripcion: string;
    idProveedor: number;
    proveedor: string;
}

export class OrdenServicioAlmacen
{
    idOrdenServicio: number;
    ordenServicio: string;
    fechaIngreso: Date;
    fechaPlanTrabajo: Date;
    aseguradora: string;
    magnitud: string;
    proceso: string;
    marcar: boolean;
}

export class OrdenServicioInventario {
    idOrdenServicio: number;
    ordenServicio: string;
    tipo: string;
    inventario: DetalleInventarioSucursal[];
}

export class ImprimirOrdenServicio extends OrdenServicioAlmacen {
    seleccionado: boolean;
}

export class UnidadMedida {
    idUnidadMedida: number;
    clave: string;
    unidad: string;
}

export class EntradaAlmacen {
    idCotizacionDetalle: number = 0;
    cantidad: number = 1;
    fechaRecepcion: Date = new Date();
    recibido: boolean = true;
    comentario: string = '';
    idEmpleado: number = 0;
    idProveedor: number = 0;
    idRefaccion: number = 0;
    nuevaRefaccion: boolean = false;
    refaccion: string = '';
    idUnidadMedida: number = 0;
}

export class Refaccion {
    idRefaccion: number;
    descripcion: string;
    idUnidadMedida: number;
}

export class PlanTrabajoAlmacen {
    idOrdenServicio: number = 0;
    cantidad: number = 0;
    descripcion: string = '';
    plan: string = '';
    autorizado: boolean = false;
    recibido: boolean = false;
    fechaRecepcion: Date;
    fechaOperativo: Date;
    operativo: string = '';
}

export class DetalleInventarioSucursal {
    cantidad: number;
    descripcion: string;
    fechaIngreso: string;
    fechaSalida: string;
    idEmpleado: number;
    idValuacionDetalle: number;
}


// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/model/classes/almacen.ts